<template>
  <div>
    <div class="big text-center" v-if="excluded_members">
      {{ $t("exclude_members_modal_header") | capitalize }}
    </div>
    <div class="big text-center" v-else>
      {{ $t("select_members_to_participate") | capitalize }}
    </div>
    <p v-if="excluded_members">
      {{ $t("exclude_members_modal_sub_text") }}
    </p>
    <div>
    <a
      href="#"
      style="text-decoration:underline;"
      class="text-info"
      v-if="editable"
      @click.prevent="toggleAll"
    >
      {{ selectAllDisplayText | capitalize }}
    </a>
  </div>
    <b-form-group>
      <b-form-checkbox-group
        v-model="selectedMembers"
        :options="options"
        name="upa-members"
        size="lg"
        :disabled="!editable"
        stacked
      />
    </b-form-group>
    <div class="d-flex justify-content-end">
      <b-button
        class="add-btn btn-outline-secondary"
        @click="$emit('close')"
      >
        <span>{{ $t('cancel') | capitalize }}</span>
      </b-button>
      <b-button
        v-if="editable"
        size="lg"
        class="add-btn ml-3 btn-primary"
        variant="primary"
        @click="save"
      >
        <span>{{ $t('save') | capitalize }}</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { api } from "@/main"

export default {
  name: "MembersSelector",
  data () {
    return {
      members: [],
      selectedMembers: [],
      allSelected: false,
    }
  },
  computed: {
    options () {
      return this.members.map(member => ({ text: member.username, value: member.id }))
    },
    selectAllDisplayText () {
      return this.allSelected ? this.$t("clear_all") : this.$t("select_all")
    },
  },
  methods: {
    save () {
      let url
      let data
      if(this.excluded_members){
        url = `fund-allocation-iterations/${this.allocation.id}/excluded_members/`
        data = { orgs_to_exclude: this.selectedMembers }
      }else{
        url = `fund-allocation-iterations/${this.allocation.id}/upa/shares/`
        data = { orgs_to_share: this.selectedMembers }
      }
      api
        .post(url, data)
        .then(() => {
          this.$emit("save", this.selectedMembers)
          this.$emit("close")
        })
        .catch(err => {
          this.$toasted.global.toast(err.response.data.orgs_to_share[0])
        })
    },
    toggleAll () {
      if (!this.editable) return
      const allMembers = this.members.map(member => member.id)
      this.selectedMembers = this.selectedMembers.length === allMembers.length ? []: allMembers
    }
  },
  watch: {
    selectedMembers (selected) {
      this.allSelected = selected.length === this.members.length
    }
  },
  mounted () {
    api
      .get("fund-allocation-iterations/upa/members/")
      .then(response => {
        this.members = response.data
        this.selectedMembers = this.excluded_members ? this.allocation.excluded_members: this.allocation.upa_members
        this.allSelected = this.selectedMembers.length === this.members.length
      })
      .catch(err => {
        this.$toasted.global.toast(err)
      })
  },
  props: {
    allocation: {
      type: Object,
      required: true
    },
    editable: Boolean,
    excluded_members: Boolean
  }
}
</script>
